// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary[data-v-4eab6190]{color:#c81919}.warning--icon[data-v-4eab6190]{cursor:pointer;color:#c81919}", ""]);
// Exports
module.exports = exports;
